import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const PortalAuthCtx = createContext(null);

export function PortalAuthProvider({ children }) {
  const [user, setUser] = useState(null); // null while checking, false = logged out, object = logged in
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    // Skip the /me check if we're mid-OAuth callback — AuthCallback will handle it.
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/portal/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const logout = async () => {
    try { await api.post("/portal/auth/logout"); } catch { /* silent */ }
    try { localStorage.removeItem("elevare_portal_token"); } catch { /* silent */ }
    setUser(false);
  };

  return (
    <PortalAuthCtx.Provider value={{ user, loading, setUser, refresh, logout }}>
      {children}
    </PortalAuthCtx.Provider>
  );
}

export const usePortalAuth = () => useContext(PortalAuthCtx);
